import "../../sass/layout/programsList/programsList.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProgramListContainer from "../programs/programsListContainer";
import MenuPath from "../path/MenuPath";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchProgramsDetails, fetchRetireePrograms } from "../../services/actions/programs.action";

const isRetireesPage = () =>
  window.location.pathname === "/retirees/programslist";

const ProgramList = () => {
  const { t } = useTranslation();
  const { programs } = useSelector((state) => ({
    programs: state.programReducer.programsList || [],
  }));

  const location = useSelector((state) => state.homeReducer.location?.data);
  const memberID = location?.uniqueNonGuessableId;

  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    // Check if this is the retirees page and we have a saved retiree ID
    const savedRetireeId = localStorage.getItem('selectedRetireeId');

    if (isRetireesPage() && savedRetireeId) {
      fetchRetireePrograms(dispatch, savedRetireeId);
    } else {
      fetchProgramsDetails(dispatch, "HEALTH", memberID);
    }
  }, [dispatch, location, memberID]);

  return (
    <div>
      <Row className="row-box-container">
        <Col className="container-data-programs-list">
          <Row className="row-menu-container">
            <MenuPath name={t("programs.programs")} />
          </Row>
          {!isRetireesPage() && (
            <div style={{
              display: 'flex',
              marginLeft: '17px',
              position: 'relative',
              top: '-15px',
              marginTop: 0,
            }}>
              <span
                className="programs-bcbs-title"
                style={{ color: "#0000ff", marginLeft: "0.5rem", marginRight: '0.5rem' }}>●</span>
              <p
                className="programs-bcbs-title"
              >
                {t("programs.blueCrossSubscribersOnly")}
              </p>
            </div>
          )}
          <ProgramListContainer
            programs={programs}
            preferRetireeImage={isRetireesPage()}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ProgramList;
